import { render, staticRenderFns } from "./CancelTransport.vue?vue&type=template&id=74f34944&scoped=true"
import script from "./CancelTransport.vue?vue&type=script&lang=js"
export * from "./CancelTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f34944",
  null
  
)

export default component.exports